import { render, staticRenderFns } from "./Questionnaires.vue?vue&type=template&id=3fb80f25&scoped=true"
import script from "./Questionnaires.vue?vue&type=script&lang=ts"
export * from "./Questionnaires.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb80f25",
  null
  
)

export default component.exports